// Toolbar well component - dark semi-transparent container for toolbar buttons

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

/**
 * Toolbar well container
 * Used as the background/container for groups of toolbar buttons
 * Set direction="row" for horizontal layout (default is column)
 */
class ToolbarWell extends BaseComponent {
  static properties = {
    direction: { type: String },
  };

  static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      background: rgba(0, 0, 0, 0.8);
      padding: 12px;
      border-radius: 8px;
      border: 1px solid #444;
      backdrop-filter: blur(4px);
    }

    :host([direction='row']) {
      flex-direction: row;
    }

    /*
     * Slotted .tool-separator children — direction-aware. The rule the
     * call sites set (\`height: 1px\`) collapses in vertical wells because
     * \`align-items: center\` doesn't stretch and the div has no width.
     * \`align-self: stretch\` fills the cross-axis of whichever direction
     * the well is in; \`flex: 0 0 1px\` fixes the main-axis size to 1px.
     * In column wells you get a horizontal hairline; in row wells you get
     * a vertical one — same markup either way.
     */
    ::slotted(.tool-separator) {
      align-self: stretch;
      flex: 0 0 1px;
      background: #444;
      margin: 4px 0;
    }
  `;

  constructor() {
    super();
    this.direction = 'column';
  }

  render() {
    return html`<slot></slot>`;
  }
}

customElements.define('toolbar-well', ToolbarWell);
